module.exports = __webpack_public_path__ + "img/thumbnail-side-by-side.b4687782.webp";